var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87991 20.1232V11.5034L13.3291 3.0542H2.44148C1.10035 3.0542 0.00305176 4.15149 0.00305176 5.49263V22.5616C0.00305176 23.9028 1.10035 25.0001 2.44148 25.0001H19.5105C20.8516 25.0001 21.9489 23.9028 21.9489 22.5616V11.674L13.4998 20.1232H4.87991Z",
    fill: "#F3C623"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3183 17.6849H12.4878L21.2661 8.90653L16.0966 3.73706L7.3183 12.5154V17.6849Z",
    fill: "#F3C623"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2776 2.43233L22.5585 0.713241C21.6076 -0.237747 20.0592 -0.237747 19.1082 0.713241L17.8158 2.00561L22.9853 7.17508L24.2776 5.88271C25.2408 4.93172 25.2408 3.38332 24.2776 2.43233Z",
    fill: "#F3C623"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a03add258cc5facf59c408352a6895ec.svg";
export { ForwardRef as ReactComponent };